import FormControl from "@material-ui/core/FormControl";
export default FormControl;

export let styles = theme => ({
  root: {
    "&:not(.MuiFormControl-fullWidth)": {
      width: "250px"
    },
    ".MuiAutocomplete-multiple &:not(.MuiFormControl-fullWidth)": {
      width: "300px"
    }
  }
});
